export type DatepickerV2Preset = 'default' | 'compact' | 'dense';
export type DatepickerV2PickerType = 'both' | 'calendar' | 'timer';
